import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { PromptEngHeroSection } from "@/components/insights/prompt-engineering/PromptEngHeroSection";
import { PromptEngTakeaway } from "@/components/insights/prompt-engineering/PromptEngTakeaway";
import { PromptEngFounderQuote } from "@/components/insights/prompt-engineering/PromptEngFounderQuote";
import { PromptEngTechniques } from "@/components/insights/prompt-engineering/PromptEngTechniques";
import { PromptEngExamples } from "@/components/insights/prompt-engineering/PromptEngExamples";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { RelatedTools } from "@/components/RelatedTools";
import { TableOfContents } from "@/components/TableOfContents";

const PromptEngineeringDevelopers = () => {
  return (
    <>
      <InsightEngagementTracker slug="prompt-engineering-developers" title="Prompt Engineering for Developers" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb 
          category="AI Development" 
          currentPage="Prompt Engineering" 
        />
        <PromptEngHeroSection />
        
        <AnimatedSection delay={100} className="mt-10 sm:mt-12">
          <PromptEngTakeaway />
        </AnimatedSection>

        <AnimatedSection delay={50} className="mt-8 sm:mt-10">
          <PromptEngFounderQuote />
        </AnimatedSection>

        <div className="section-divider" />

        <AnimatedSection delay={0}>
          <PromptEngTechniques />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <PromptEngExamples />
        </AnimatedSection>
        
        <AnimatedSection delay={0}>
          <RelatedTools insightSlug="prompt-engineering-developers" />
        </AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default PromptEngineeringDevelopers;
